import Card from "@/components/game/Card";

export default function Board({ cards, onCard, isSpymaster, disabled, lastRevealedIdx, turn, phase }) {
  const isRed = turn === "red";
  const colorRgb = isRed ? "220, 38, 38" : "37, 99, 235"; 
  
  const tintBg = phase === "ended"
    ? "var(--surface-elev)"
    : "transparent";
    
  const tintBorder = phase === "ended"
    ? "var(--border)"
    : `rgba(${colorRgb}, 1)`;
    
  return (
    <div
      data-testid="game-board"
      data-turn={turn}
      className="grid grid-cols-5 gap-2 sm:gap-3 w-full aspect-square max-w-xl mx-auto p-2 sm:p-3 border-[6px] sm:border-[8px] rounded-lg shadow-2xl transition-colors duration-300"
      style={{ background: tintBg, borderColor: tintBorder }}
    >
      {cards.map((c) => (
        <Card
          key={c.index}
          card={c}
          onClick={() => onCard(c.index)}
          isSpymaster={isSpymaster}
          disabled={disabled}
          justRevealed={lastRevealedIdx === c.index}
        />
      ))}
    </div>
  );
}
